<template>
<div>
    <v-card dark class="pa-4 grey darken-3 ma-4">
        <v-toolbar dark flat dense class="grey darken-3">
            <v-toolbar-title>Завантажити коди Megogo</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
                <v-flex xs12 lg6>
                    <v-select v-model="f.service_type" item-text="name" item-value="id" label="Оберіть пакет" :items="list" ></v-select>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-textarea v-model="f.codes" label="Коди Megogo" ></v-textarea>
                </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="grey" @click="goBack()">
                <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
            </v-btn>
            <v-btn small text @click="exportData()" class="megogo--text">
                Завантажити <v-icon class="pl-3">mdi-export</v-icon>
            </v-btn>

        </v-card-actions>
    </v-card>
</div>
</template>

<script>

import {
    mapActions
} from 'vuex'

export default {
    data() {
        return {
            f: {},
        }
    },
    methods: {
        ...mapActions(['setSnackbar', 'touch','getMegogoList','importMegogoCodes']),
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
        },
        getUsers() {
            this.usersTable = true
            this.getDataFromApi()
        },
        exportData() {
            this.importMegogoCodes(this.f)
            .then(() => {
                this.f = {}
                this.setSnackbar(['info', 'Коди Megogo вдало завантажено'])

            })
            .catch(error => {
                this.setSnackbar(['error', error])
                console.error(error)
                })
        },
    },
    created() {
        this.getMegogoList()
    },
    computed: {
        list() {
            return this.$store.state.adminpanel.megogoList
        },
    },
    watch: {}
}
</script>

<style>
.inp-cnt {
    color: black;
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid rgb(7, 0, 0);
    width: 40px;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
}
</style>
